const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
        // sorter: true,
    },
    {
        title: 'Mobile No',
        dataIndex: 'phoneNo',
        render: defaultRender,
    },
    {
        title: 'Level',
        dataIndex: 'level',
        // sorter: true,
    },
    {
        title: 'FTD',
        dataIndex: 'ftdVerify',
        render: defaultRender,
    },
    {
        title: 'Referral Code',
        dataIndex: 'referralCode',
        render: defaultRender,
    },
    {
        title: 'Affiliate Code',
        dataIndex: 'affiliateCode',
        render: defaultRender,
    },
    {
        title: 'User Type',
        dataIndex: 'userType',
        render: defaultRender,
    },
    {
        title: 'Registered Date',
        dataIndex: 'createdDate',
        render: defaultRender,
        // sorter: true,
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        render: defaultRender,
    },
];

export default columns;